import React, { useContext, useState } from 'react';
import { CaptionText, Button, DropdownMenu, CoachTip } from '@paypalcorp/pp-react';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';
import { useSelector } from 'react-redux';
import LoadingOverlay from '../../../components/LoadingOverlay';
import { createOrder } from '../../../util/sdkCallbacks';
import TestPanelContext from '../StateManagement/TestPanelContext';
import styles from '../Configurator.module.less';
import clientLogger from '../../../lib/logger';

const PaymentTokens = () => {
  const {
    VaultSetupTokenConfigurator: {
      paymentTokens: { options, selected },
      updateVaultSetupOption
    },
    SdkConfigurator: { sdkSettings },
    OrderConfigurator: { amount: { value: orderAmount } = {}, sellerId } = {},
    code: { status: { handleShippingAddress = false } = {} } = {}
  } = useContext(IntegrationPageSectionContext);

  const { updateLogs, toggleTestPanel } = useContext(TestPanelContext);

  const [loading, setLoading] = useState(false);
  const [isCoachOpen, setIsCoachOpen] = useState(false);

  const csrfToken = useSelector((state) => state?.app?.csrfToken);
  const appIntegrationType = useSelector((state) => state?.app?.appIntegrationType);
  const isUserLoggedIn = useSelector((state) => state?.app?.prunedUser?.isUserLoggedIn);
  const { clientId } = sdkSettings;

  const handleOnChange = (event) => {
    try {
      updateVaultSetupOption(event.target.value, 'paymentTokens.selected');
    } catch (error) {
      clientLogger.error('CLIENT:ERROR', { error });
    }
  };

  const handleCreateOrder = async () => {
    if (options.length === 0) {
      setIsCoachOpen(true);
    } else {
      setLoading(true);
      const paymentSource = {
        paypal: {
          vault_id: selected,
          stored_credential: {
            payment_initiator: 'MERCHANT',
            usage: 'SUBSEQUENT',
            usage_pattern: 'RECURRING_POSTPAID'
          }
        }
      };

      const orderId = await createOrder({
        currencyCode: sdkSettings?.currency,
        amount: orderAmount,
        intent: sdkSettings?.intent,
        enableShippingOptions: handleShippingAddress,
        csrfToken,
        updateLogs,
        clientId: isUserLoggedIn ? clientId : null,
        appIntegrationType,
        paymentSource,
        sellerId,
        product: 'recurring'
      });
      toggleTestPanel(true);
      setLoading(false);
      return orderId;
    }
  };

  return (
    <>
      {loading && <LoadingOverlay />}
      <div className={styles.configuration}>
        <div className={styles.configuration_item}>
          <CaptionText className={styles.configuration_text}>Payment Tokens:</CaptionText>
          <DropdownMenu
            className={styles.configuration_dropdown}
            id="simple"
            label="Select a payment token"
            options={options.map((v) => ({ label: v, value: v }))}
            value={selected}
            onChange={handleOnChange}
            onClose={() => {}}
          />
        </div>
        <div className={styles.button_container}>
          <Button id={'create-order-button'} onClick={handleCreateOrder}>
            Create Order
          </Button>
        </div>
      </div>
      {isCoachOpen && (
        <CoachTip
          caretPos="top-center"
          targetElementId={'create-order-button'}
          text={'Press the PayPal button to generate a payment token.'}
          isOpen
          onClose={() => setIsCoachOpen(false)}
        />
      )}
    </>
  );
};

export default PaymentTokens;
